import { Image, Notification } from '../design-system';

type Props = {
  count: number;
  /** Thumbnail of a vaulted card; null → the pill goes without one. */
  imageUrl: string | null;
};

/** The vault toast (sleek only): a small card thumbnail and the count, in
 *  the same flat card as the sleek buyback toast. */
export function VaultedToastBody({ count, imageUrl }: Props) {
  const sentence = count === 1 ? '1 card has been added to your vault' : `${count} cards have been added to your vault`;
  return (
    <Notification
      variant="card"
      // Right-click opens the vault toast's own switches; its look still
      // comes from the shared Notification knobs.
      inspectName="VaultedNotification"
      icon={
        imageUrl ? (
          <Image
            src={imageUrl}
            alt=""
            className="relative h-7 w-5 shrink-0"
            imgClassName="absolute inset-0 h-full w-full object-contain"
            width={20}
            height={28}
          />
        ) : undefined
      }
    >
      {sentence}
    </Notification>
  );
}
